import {
  TextLargeParagraph,
  type TextLargeParagraphProps,
} from '@carboncopyco/ui';

export type RulesManagerEmptySearchProps = {
  ruleType?: string;
};

const Text = ({ label }: Pick<TextLargeParagraphProps, 'label'>) => (
  <TextLargeParagraph
    label={label}
    color="text-ds-natural-600"
  />
);

export const RulesManagerEmptySearch = ({
  ruleType = 'rules',
}: RulesManagerEmptySearchProps) => {
  return (
    <div className="flex flex-col flex-1 items-center justify-center">
      <div className="flex flex-col justify-center items-center">
        <Text label={`There are no ${ruleType}`} />
        <Text label="that match your search" />
      </div>
    </div>
  );
};
